// Labels affichables dérivés des catégories utilisées pour les icônes (groceryCategoryIcon.js),
// pour proposer une liste fixe cohérente lors de l'enregistrement d'un produit épicerie.
export const GROCERY_PRODUCT_CATEGORIES = [
  'Africain',
  'Asiatique',
  'Boissons',
  'Céréales',
  'Condiments',
  'Confitures',
  'Conserves',
  'Desserts',
  'Épices',
  'Européen',
  'Farines',
  'Fast-food',
  'Fromages',
  'Huiles',
  'Infusions',
  'Légumes secs',
  'Légumineuses',
  'Pâtes',
  'Petit-déjeuner',
  'Snacks',
  'Sucres',
  'Végétarien',
];

export default GROCERY_PRODUCT_CATEGORIES;
